import { render } from "./AppHomeButton.vue?vue&type=template&id=01bf94e6&scoped=true"
import script from "./AppHomeButton.vue?vue&type=script&lang=js"
export * from "./AppHomeButton.vue?vue&type=script&lang=js"

import "./AppHomeButton.vue?vue&type=style&index=0&id=01bf94e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bf94e6"]])

export default __exports__